import Laravel from '@/services/Laravel'

export default {
  async exists(phone) {
    phone = phone.replace(/\D/g, '')
    try {
      let { data: customerData } = await Laravel.post(
        `/customer/phone-exists/`,
        { phone }
      )
      return customerData
    } catch (error) {
      return Promise.reject(error)
    }
  }, // exists

  async sendCode(phone) {
    phone = phone.replace(/\D/g, '')
    try {
      let { data: success } = await Laravel.post(`/user-code/send/`, {
        phone,
      })
      return success
    } catch (error) {
      return Promise.reject(error)
    }
  }, // sendCode

  async verify({ phone, code }) {
    phone = phone.replace(/\D/g, '')
    try {
      let { data: customerData } = await Laravel.post(`/user-code/verify/`, {
        phone,
        code,
      })
      return customerData
    } catch (error) {
      return Promise.reject(error)
    }
  }, // verify

  async find(customerId) {
    try {
      let { data: customer } = await Laravel.get(`/customers/${customerId}`)
      return customer
    } catch (error) {
      return Promise.reject(error)
    }
  },

  // async find(customerId, userData) {
  //   try {
  //     let { data: customer } = await Laravel.post(
  //       `/shops/${shopId}/customers/${phone}`
  //     )
  //     return customer
  //   } catch (error) {
  //     return Promise.reject(error)
  //   }
  // },

  async validateLegacyAccount(credentials) {
    try {
      let { data: validated } = await Laravel.post(
        '/legacy-customer/validate',
        credentials
      )
      return validated
    } catch (err) {
      return Promise.reject(err)
    }
  }, // validateLegacyAccount
}
